{
  "app.navigation.account": "חשבון",
  "app.navigation.billing": "חיוב",
  "app.navigation.integrations": "אינטגרציות",
  "app.navigation.occasions": "אירועים",
  "app.navigation.overview": "סקירה כללית",
  "app.navigation.settings": "הגדרות",
  "app.navigation.support": "תמיכה",
  "app.router.app_router_retry_session_load": "נסה לטעון את ההפעלה מחדש",
  "components.actor_editor_form.not_set": "לא הוגדר",
  "components.app_shell.components_app_shell_tap_share_in_safari": "הקש על שיתוף ב‑Safari",
  "components.app_shell.components_app_shell_view_account": "הצג חשבון",
  "components.app_shell.sign_out": "התנתק",
  "components.billing_plan_gate.change_plan": "שנה תוכנית",
  "components.billing_plan_gate.current_plan": "תוכנית נוכחית",
  "components.billing_plan_gate.plan_required": "נדרשת תוכנית",
  "components.billing_plan_gate.plan_required_description": "תכנון נדרש תיאור",
  "components.billing_plan_gate.required_plan": "תוכנית נדרשת",
  "components.cached_data_notice.reconnect_to_refresh": "התחבר מחדש כדי לרענן",
  "components.cached_data_notice.showing_saved_data_from": "מציג נתונים שמורים מ‑",
  "components.cached_data_notice.showing_saved_data_some_details_may_be_outdated": "מציג נתונים שמורים, ייתכן שחלק מהפרטים אינם מעודכנים",
  "components.calendar.more": "עוד",
  "components.color_picker.mode": "מצב",
  "components.combobox.components_combobox_no_matching_options": "אין אפשרויות תואמות",
  "components.combobox.components_combobox_search_options": "חפש אפשרויות",
  "components.combobox.components_combobox_select_option": "בחר אפשרות",
  "components.data_views.bulk_actions.add_to_group": "הוסף לקבוצה",
  "components.data_views.bulk_actions.add_to_household": "הוסף למשק בית",
  "components.data_views.bulk_actions.change_status": "שנה סטטוס",
  "components.data_views.bulk_actions.change_status_to": "שנה סטטוס ל‑",
  "components.data_views.bulk_actions.choose_target": "בחר יעד",
  "components.data_views.bulk_actions.create_target": "צור יעד",
  "components.data_views.bulk_actions.search_groups": "חפש קבוצות",
  "components.data_views.bulk_actions.search_households": "חפש משקי בית",
  "components.data_views.bulk_actions.select_row": "בחר שורה",
  "components.data_views.bulk_actions.select_visible_rows": "בחר שורות גלויות",
  "components.data_views.bulk_actions.this_action_cannot_be_undone": "לא ניתן לבטל פעולה זו",
  "components.data_views.collection_calendar_view.components_data_views_add_item": "הוסף פריט",
  "components.data_views.collection_calendar_view.components_data_views_next": "הבא",
  "components.data_views.collection_calendar_view.components_data_views_next_year": "השנה הבאה",
  "components.data_views.collection_calendar_view.components_data_views_previous": "הקודם",
  "components.data_views.collection_calendar_view.components_data_views_previous_year": "השנה הקודמת",
  "components.data_views.collection_calendar_view.components_data_views_today": "היום",
  "components.data_views.collection_calendar_view.day_view": "תצוגת יום",
  "components.data_views.collection_calendar_view.month_view": "תצוגת חודש",
  "components.data_views.collection_calendar_view.week_view": "תצוגת שבוע",
  "components.data_views.collection_gantt_view.rgb_100_116_139": "Rgb 100 116",
  "components.data_views.collection_gantt_view.rgb_225_29_72": "Rgb 225 29",
  "components.data_views.collection_gantt_view.rgb_59_130_246": "Rgb 59 130",
  "components.data_views.collection_table_view.actions": "פעולות",
  "components.data_views.data_view_column_preferences_menu.customize_table": "התאם טבלה",
  "components.data_views.data_view_column_preferences_menu.delete_preset": "מחק הגדרה מראש",
  "components.data_views.data_view_column_preferences_menu.display_options": "אפשרויות תצוגה",
  "components.data_views.data_view_column_preferences_menu.export": "ייצוא",
  "components.data_views.data_view_column_preferences_menu.group_by": "קבץ לפי",
  "components.data_views.data_view_column_preferences_menu.no_grouping": "ללא קיבוץ",
  "components.data_views.data_view_column_preferences_menu.reorder_column": "סדר מחדש עמודה",
  "components.data_views.data_view_column_preferences_menu.save_preset": "שמור הגדרה מראש",
  "components.data_views.data_view_column_preferences_menu.search_presets": "חפש הגדרות קבועות מראש",
  "components.data_views.data_view_shell.customize_view": "התאם תצוגה",
  "components.data_views.data_view_table.load_more": "טען עוד",
  "components.data_views.export_dialog.all_items": "כל הפריטים",
  "components.data_views.export_dialog.current_filter": "מסנן נוכחי",
  "components.data_views.export_dialog.current_page": "עמוד נוכחי",
  "components.data_views.export_dialog.export": "ייצוא",
  "components.data_views.export_dialog.export_failed": "הייצוא נכשל",
  "components.data_views.export_dialog.export_ready": "ייצוא מוכן",
  "components.data_views.export_dialog.exporting": "מייצא",
  "components.data_views.export_dialog.fields": "שדות",
  "components.data_views.export_dialog.format": "פורמט",
  "components.data_views.export_dialog.items": "פריטים",
  "components.data_views.export_dialog.select_at_least_one_field": "בחר שדה אחד לפחות",
  "components.data_views.gantt_link_dependency": "תלות ב-Gantt Link",
  "components.data_views.gantt_reset_zoom": "גאנט איפוס זום",
  "components.data_views.gantt_scale_daily": "קנה מידה גאנט יומי",
  "components.data_views.gantt_scale_monthly": "סולם גאנט חודשי",
  "components.data_views.gantt_scale_quarterly": "סולם גאנט רבעוני",
  "components.data_views.gantt_timeline_scale": "סולם ציר הזמן של גאנט",
  "components.data_views.gantt_timeline_zoom": "זום ציר הזמן של גאנט",
  "components.data_views.gantt_zoom_in": "גאנט זום אין",
  "components.data_views.gantt_zoom_out": "גאנט זום אאוט",
  "components.date_time_picker.components_date_time_picker_am": "לפנה״צ",
  "components.date_time_picker.components_date_time_picker_day": "יום",
  "components.date_time_picker.components_date_time_picker_month": "חודש",
  "components.date_time_picker.components_date_time_picker_next_month": "החודש הבא",
  "components.date_time_picker.components_date_time_picker_period": "תקופה",
  "components.date_time_picker.components_date_time_picker_pick_a_date": "בחר תאריך",
  "components.date_time_picker.components_date_time_picker_pm": "אחה״צ",
  "components.date_time_picker.components_date_time_picker_previous_month": "החודש הקודם",
  "components.date_time_picker.components_date_time_picker_second": "שנייה",
  "components.date_time_picker.components_date_time_picker_year": "שנה",
  "components.date_time_picker.hours": "שעות",
  "components.date_time_picker.minutes": "דקות",
  "components.date_time_picker.pp": "Pp",
  "components.date_time_picker.pp_hh_00": "Pp Hh",
  "components.date_time_picker.pp_hh_b": "Pp Hh b",
  "components.date_time_picker.pp_hh_mm": "Pp Hh Mm",
  "components.date_time_picker.pp_hh_mm_b": "Pp Hh Mm b",
  "components.date_time_picker.pp_hh_mm_ss": "Pp Hh Mm Ss",
  "components.date_time_picker.pp_hh_mm_ss_b": "Pp Hh Mm Ss b",
  "components.date_time_picker.seconds": "שניות",
  "components.delete_confirmation_dialog.are_you_sure": "האם אתה בטוח",
  "components.delete_confirmation_dialog.this_action_cannot_be_undone": "לא ניתן לבטל פעולה זו",
  "components.dialog_page.deleting": "מוחק",
  "components.dropzone.accepts": "מקבל",
  "components.dropzone.and": "וגם",
  "components.dropzone.at_least": "לפחות",
  "components.dropzone.between": "בין",
  "components.dropzone.drag_and_drop_or_click_to_replace": "גרור ושחרר או לחץ להחלפה",
  "components.dropzone.drag_and_drop_or_click_to_upload": "גרור ושחרר או לחץ להעלאה",
  "components.dropzone.less_than": "פחות מ‑",
  "components.dropzone.upload_a_file": "העלה קובץ",
  "components.dropzone.upload_files": "העלה קבצים",
  "components.gantt.issues": "בעיות",
  "components.gantt.remove_marker": "הסר סימון",
  "components.install_app.components_install_app_ios_safari_requires_manual_install_steps": "Safari ב‑iOS דורש שלבי התקנה ידניים",
  "components.localized_fields.components_localized_fields_ai_prefill": "מילוי מקדים באמצעות AI",
  "components.localized_fields.components_localized_fields_change_primary": "שנה ראשי",
  "components.localized_fields.components_localized_fields_multi": "רב‑לשוני",
  "components.localized_fields.components_localized_fields_multi_language_view": "תצוגה רב‑לשונית",
  "components.offline_action_unavailable_message.this_action_is_unavailable_while_offline": "פעולה זו אינה זמינה במצב לא מקוון",
  "components.offline_banner.you_are_offline_some_features_may_be_unavailable_until_your_connection": "אתה במצב לא מקוון. חלק מהתכונות עשויות לא להיות זמינות עד שהחיבור יחזור",
  "components.offline_empty_cache_state.this_page_is_unavailable_offline_because_it_has_not_been_loaded": "עמוד זה אינו זמין במצב לא מקוון מפני שהוא עדיין לא נטען",
  "components.offline_state_panel.cannot_verify_your_session_while_offline": "לא ניתן לאמת את ההפעלה שלך במצב לא מקוון",
  "components.offline_state_panel.reconnect_to_continue": "התחבר מחדש כדי להמשיך",
  "components.resizable.components_resizable_panel_group_resize_panels": "שנה את גודל הפאנלים בקבוצת הפאנלים",
  "components.seating_layout_planner.components_seating_layout_planner_assigned_seat": "מקום מוקצה",
  "components.seating_layout_planner.components_seating_layout_planner_fit": "התאם",
  "components.seating_layout_planner.components_seating_layout_planner_open_seat": "מקום פנוי",
  "components.seating_layout_planner.components_seating_layout_planner_pending_rsvp": "ממתין לאישור הגעה",
  "components.seating_layout_planner.components_seating_layout_planner_rotate": "לְסוֹבֵב",
  "components.seating_layout_planner.components_seating_layout_planner_tables": "שולחנות",
  "components.shell.account_delete_failed_title": "מחיקת החשבון נכשלה",
  "components.shell.chat": "צ׳אט",
  "components.shell.components_shell_99": "99",
  "components.shell.components_shell_account_actions": "פעולות חשבון",
  "components.shell.components_shell_ai_assistant": "עוזר AI",
  "components.shell.components_shell_ai_prompt": "בקשת AI",
  "components.shell.components_shell_all_channels": "כל הערוצים",
  "components.shell.components_shell_all_statuses": "כל הסטטוסים",
  "components.shell.components_shell_ask_ai": "שאל את AI",
  "components.shell.components_shell_change_password": "שנה סיסמה",
  "components.shell.components_shell_channels": "ערוצים",
  "components.shell.components_shell_could_not_archive_this_notification": "לא ניתן היה להעביר את ההתראה לארכיון",
  "components.shell.components_shell_could_not_restore_this_notification": "לא ניתן היה לשחזר את ההתראה",
  "components.shell.components_shell_delete_account": "מחק חשבון",
  "components.shell.components_shell_filter_notifications_by_channel": "סנן התראות לפי ערוץ",
  "components.shell.components_shell_filter_notifications_by_status": "סנן התראות לפי סטטוס",
  "components.shell.components_shell_how_can_we_help": "כיצד נוכל לעזור?",
  "components.shell.components_shell_in_occasion": "באירוע",
  "components.shell.components_shell_language_preference": "העדפת שפה",
  "components.shell.components_shell_linked_contacts": "אנשי קשר מקושרים",
  "components.shell.components_shell_loading_notifications": "טוען התראות",
  "components.shell.components_shell_manage_cookie_preferences": "נהל העדפות עוגיות",
  "components.shell.components_shell_mark_all_as_read": "סמן הכל כנקרא",
  "components.shell.components_shell_mark_all_notifications_as_read": "סמן את כל ההתראות כנקראו",
  "components.shell.components_shell_new_password": "סיסמה חדשה",
  "components.shell.components_shell_no_linked_contacts_are_connected_to_this_account": "אין אנשי קשר מקושרים המחוברים לחשבון זה",
  "components.shell.components_shell_no_notifications_yet": "אין התראות עדיין",
  "components.shell.components_shell_not_configured": "לא מוגדר",
  "components.shell.components_shell_notification": "התראה",
  "components.shell.components_shell_notifications": "התראות",
  "components.shell.components_shell_notifications_are_not_configured": "ההתראות אינן מוגדרות",
  "components.shell.components_shell_open_ai_assistant": "פתח את עוזר ה‑AI",
  "components.shell.components_shell_open_notifications": "פתח התראות",
  "components.shell.components_shell_profile": "פרופיל",
  "components.shell.components_shell_profile_image": "תמונת פרופיל",
  "components.shell.components_shell_refresh_notifications": "רענן התראות",
  "components.shell.components_shell_remove_image": "הסר תמונה",
  "components.shell.components_shell_running": "פועל",
  "components.shell.components_shell_save_profile": "שמור פרופיל",
  "components.shell.components_shell_saving": "שומר",
  "components.shell.components_shell_security_privacy": "אבטחה ופרטיות",
  "components.shell.components_shell_sending": "שולח",
  "components.shell.components_shell_show_archived_notifications": "הצג התראות בארכיון",
  "components.shell.components_shell_unread_only": "לא נקראו בלבד",
  "components.shell.components_shell_updating": "מעדכן",
  "components.shell.components_shell_verified": "מאומת",
  "components.shell.components_shell_verify_email": "אמת דוא״ל",
  "components.shell.email_verification_failed_title": "אימות הדוא״ל נכשל",
  "components.shell.email_verification_sent_title": "נשלח אימות דוא״ל",
  "components.shell.error": "שגיאה",
  "components.shell.in_app": "בתוך האפליקציה",
  "components.shell.notifications_could_not_be_loaded": "לא ניתן היה לטעון את ההתראות",
  "components.shell.password_update_failed_title": "עדכון הסיסמה נכשל",
  "components.shell.profile_image_invalid_title": "תמונת הפרופיל אינה תקינה",
  "components.shell.profile_save_failed_title": "שמירת הפרופיל נכשלה",
  "components.shell.push": "פוש",
  "components.shell.select_an_occasion_to_run_ai_assistance": "בחר אירוע כדי להפעיל סיוע AI",
  "components.shell.sent": "נשלח",
  "components.shell.sms": "SMS",
  "components.shell.warning": "אזהרה",
  "components.shell.what_do_you_want_me_to_do": "מה תרצה שאעשה?",
  "components.smart_table_search.components_smart_table_search_add_a_filter": "הוסף מסנן",
  "components.smart_table_search.components_smart_table_search_and_value": "וערך",
  "components.smart_table_search.components_smart_table_search_choose_a_second_value": "בחר ערך שני",
  "components.smart_table_search.components_smart_table_search_choose_a_value": "בחר ערך",
  "components.smart_table_search.components_smart_table_search_press_apply_to_add_this_filter": "לחץ על החל כדי להוסיף את המסנן הזה",
  "components.smart_table_search.components_smart_table_search_search_text_stays_active_start_with_a_filter": "טקסט החיפוש נשאר פעיל. התחל עם מסנן",
  "components.smart_table_search.contains": "מכיל",
  "components.smart_table_search.ends_with": "מסתיים ב‑",
  "components.smart_table_search.is": "הוא",
  "components.smart_table_search.is_empty": "ריק",
  "components.smart_table_search.is_exactly": "שווה בדיוק",
  "components.smart_table_search.is_greater_than": "גדול מ‑",
  "components.smart_table_search.is_in": "נמצא ב‑",
  "components.smart_table_search.is_less_than": "קטן מ‑",
  "components.smart_table_search.is_not": "אינו",
  "components.smart_table_search.is_not_empty": "אינו ריק",
  "components.smart_table_search.selected": "נבחרו",
  "components.smart_table_search.starts_with": "מתחיל ב‑",
  "components.stale_data_badge.saved_data": "נתונים שמורים",
  "components.tags_field.components_tags_field_no_matching_values": "אין ערכים תואמים",
  "components.tags_field.components_tags_field_search_values": "חפש ערכים",
  "components.tags_field.components_tags_field_select_values": "בחר ערכים",
  "components.toast.components_toast_dismiss_notification": "סגור התראה",
  "components.tov.components_tov_close_dialog": "סגור חלון",
  "config.planner_views.calendar_view": "תצוגת לוח שנה",
  "config.planner_views.data_table": "טבלת נתונים",
  "config.planner_views.gallery_view": "תצוגת גלריה",
  "config.planner_views.gantt_view": "תצוגת גאנט",
  "config.planner_views.grid_view": "תצוגת רשת",
  "config.planner_views.kanban_view": "תצוגת קנבן",
  "config.planner_views.layout_view": "תצוגת פריסה",
  "config.planner_views.list_view": "תצוגת רשימה",
  "config.planner_views.map_view": "תצוגת מפה",
  "config.planner_views.table_view": "תצוגת טבלה",
  "connectivity.use_online_action_guard.this_action_requires_an_internet_connection": "פעולה זו דורשת חיבור לאינטרנט",
  "design.design_system.action_button": "כפתור פעולה",
  "design.design_system.admin": "מנהל",
  "design.design_system.docs": "תיעוד",
  "design.design_system.field_shell": "מעטפת שדה",
  "design.design_system.guest": "אורח",
  "design.design_system.marketing": "שיווק",
  "design.design_system.meta_badge": "תג מטא",
  "design.design_system.planner": "מתכנן",
  "design.design_system.surface_card": "כרטיס",
  "design.design_system.vendor": "ספק",
  "general.actions.acknowledge": "אשר",
  "general.actions.apply": "החל",
  "general.actions.approve": "אשר",
  "general.actions.archive": "ארכיון",
  "general.actions.back": "חזור",
  "general.actions.cancel": "בטל",
  "general.actions.choose": "בחר",
  "general.actions.clear": "נקה",
  "general.actions.close": "סגור",
  "general.actions.continue": "המשך",
  "general.actions.copy": "העתק",
  "general.actions.create": "צור",
  "general.actions.delete": "מחק",
  "general.actions.disable": "השבת",
  "general.actions.dismiss": "לְפַטֵר",
  "general.actions.edit": "ערוך",
  "general.actions.enable": "הפעל",
  "general.actions.export": "ייצא",
  "general.actions.import": "ייבא",
  "general.actions.next": "הבא",
  "general.actions.open": "פתח",
  "general.actions.previous": "הקודם",
  "general.actions.refresh": "רענן",
  "general.actions.reject": "דחה",
  "general.actions.remove": "הסר",
  "general.actions.reset": "איפוס",
  "general.actions.retry": "נסה שוב",
  "general.actions.review": "סקור",
  "general.actions.save": "שמור",
  "general.actions.save_changes": "שמור שינויים",
  "general.actions.saving": "שומר",
  "general.actions.select": "בחר",
  "general.actions.share": "לַחֲלוֹק",
  "general.actions.try_again": "נסה שוב",
  "general.actions.upload": "העלה",
  "general.actions.view": "צפה",
  "general.booleans.no": "לא",
  "general.booleans.yes": "כן",
  "general.calendar.today": "היום",
  "general.empty.no_caption_provided": "לא סופק כיתוב",
  "general.empty.no_visible_message_body": "אין תוכן הודעה גלוי",
  "general.fields.action.label": "פעולה",
  "general.fields.actions.label": "Label",
  "general.fields.address.label": "כתובת",
  "general.fields.audience.label": "קהל יעד",
  "general.fields.avatar.label": "אווטאר",
  "general.fields.category.label": "קטגוריה",
  "general.fields.channel.label": "ערוץ",
  "general.fields.color.label": "צבע",
  "general.fields.country.label": "מדינה",
  "general.fields.date.label": "תאריך",
  "general.fields.default_locale.label": "שפת ברירת מחדל",
  "general.fields.description.label": "תיאור",
  "general.fields.display_name.label": "שם תצוגה",
  "general.fields.duration.label": "משך",
  "general.fields.email.label": "דוא״ל",
  "general.fields.event.label": "אירוע",
  "general.fields.first_name.label": "שם פרטי",
  "general.fields.language.label": "שפה",
  "general.fields.last_name.label": "שם משפחה",
  "general.fields.lifecycle.label": "מחזור חיים",
  "general.fields.locale.label": "שפה",
  "general.fields.location.label": "מיקום",
  "general.fields.message.label": "הודעה",
  "general.fields.name.label": "שם",
  "general.fields.note.label": "תווית",
  "general.fields.notes.label": "הערות",
  "general.fields.occasion.label": "אירוע",
  "general.fields.phone.label": "טלפון",
  "general.fields.priority.label": "עדיפות",
  "general.fields.quantity.label": "כמות",
  "general.fields.reason.label": "סיבה",
  "general.fields.response.label": "תגובה",
  "general.fields.scope.label": "תחום",
  "general.fields.search.label": "חיפוש",
  "general.fields.search.placeholder": "חיפוש",
  "general.fields.section.label": "מקטע",
  "general.fields.size.label": "גודל",
  "general.fields.slug.label": "מזהה כתובת",
  "general.fields.status.label": "סטטוס",
  "general.fields.target.label": "יעד",
  "general.fields.timezone.label": "אזור זמן",
  "general.fields.type.label": "סוג",
  "general.fields.value.label": "ערך",
  "general.fields.visibility.label": "נראות",
  "general.fields.welcome_message.label": "תווית",
  "general.filters.all": "הכול",
  "general.languages.en": "אנגלית",
  "general.languages.he": "עברית",
  "general.modules.activity.name": "פעילות",
  "general.modules.assignments.name": "הקצאות",
  "general.modules.communications.name": "תקשורת",
  "general.modules.contacts.name": "אנשי קשר",
  "general.modules.dashboard.name": "לוח בקרה",
  "general.modules.deliverables.name": "תוצרים",
  "general.modules.events.name": "אירועים",
  "general.modules.forms.name": "טפסים",
  "general.modules.gallery.name": "גלריה",
  "general.modules.locations.name": "מיקומים",
  "general.modules.messages.name": "הודעות",
  "general.modules.monitoring.name": "ניטור",
  "general.modules.overview.name": "סקירה כללית",
  "general.modules.publishing.name": "פרסום",
  "general.modules.registry.name": "רישום",
  "general.modules.rsvp.name": "RSVP",
  "general.modules.schedule.name": "לוח זמנים",
  "general.modules.seating.name": "הושבה",
  "general.modules.task_boards.name": "לוחות משימות",
  "general.modules.tasks.name": "משימות",
  "general.modules.templates.name": "תבניות",
  "general.modules.updates.name": "עדכונים",
  "general.navigation.return_to_overview": "חזרה לסקירה הכללית",
  "general.pagination.first_page": "העמוד הראשון",
  "general.pagination.last_page": "העמוד האחרון",
  "general.pagination.next_page": "העמוד הבא",
  "general.pagination.page": "עמוד",
  "general.pagination.previous_page": "העמוד הקודם",
  "general.pagination.rows_per_page": "שורות לעמוד",
  "general.pagination.zero_items_summary": "אין פריטים להצגה",
  "general.selection.select_an_option": "בחר אפשרות",
  "general.sort.ascending": "עולה",
  "general.sort.descending": "יורד",
  "general.states.access_unavailable_title": "הגישה אינה זמינה",
  "general.states.address_pending": "כתובת ממתינה",
  "general.states.empty_title": "אין פריטים",
  "general.states.error_title": "כותרת שגיאה",
  "general.states.feature_unavailable_title": "התכונה אינה זמינה",
  "general.states.loading_title": "טוען",
  "general.states.no_results_title": "אין תוצאות",
  "general.states.not_found_title": "לא נמצא",
  "general.states.occasion_not_available_title": "האירוע אינו זמין",
  "general.states.pending": "בהמתנה",
  "general.states.retry_occasion_loading": "נסה לטעון את האירוע מחדש",
  "general.states.saving": "שומר",
  "general.states.unknown_error_title": "שגיאה לא ידועה",
  "general.status.active": "פעיל",
  "general.status.approved": "אושר",
  "general.status.archived": "בארכיון",
  "general.status.attention": "Attention",
  "general.status.available": "זמין",
  "general.status.blocked": "חסום",
  "general.status.cancelled": "בוטל",
  "general.status.closed": "סגור",
  "general.status.complete": "הושלם",
  "general.status.completed": "הושלם",
  "general.status.configured": "מוגדר",
  "general.status.declined": "נדחה",
  "general.status.delivered": "נמסר",
  "general.status.disabled": "מושבת",
  "general.status.draft": "טיוטה",
  "general.status.enabled": "פעיל",
  "general.status.failed": "נכשל",
  "general.status.fulfilled": "הושלם",
  "general.status.idle": "לא פעיל",
  "general.status.in_progress": "בתהליך",
  "general.status.loading": "טוען",
  "general.status.locked": "נעול",
  "general.status.off": "כבוי",
  "general.status.on": "פועל",
  "general.status.optional": "אופציונלי",
  "general.status.overdue": "באיחור",
  "general.status.pending": "ממתין",
  "general.status.published": "פורסם",
  "general.status.ready": "Ready",
  "general.status.rejected": "נדחה",
  "general.status.required": "חובה",
  "general.status.revoked": "בוטל",
  "general.status.saving": "שומר",
  "general.status.scheduled": "מתוזמן",
  "general.status.submitting": "שולח",
  "general.status.unavailable": "לא זמין",
  "general.status.unknown": "לא ידוע",
  "general.status.upcoming": "קרוב",
  "general.time.after": "אחרי",
  "general.time.before": "לפני",
  "general.units.kb": "KB",
  "general.values.no": "לא",
  "general.values.yes": "כן",
  "landing.environment.local": "מקומי",
  "landing.environment.non_production": "לא ייצור",
  "landing.environment.staging": "סטייג׳ינג",
  "landing.environment.tag_label": "תג סביבת עבודה",
  "pages.billing_page.billing_owner": "Billing Owner",
  "pages.billing_page.no_promotions": "No Promotions",
  "pages.billing_page.promotions": "Promotions",
  "pages.form_details_page.revision": "Revision",
  "pages.forms_page.pages_forms_page_reset_local_draft": "אפס טיוטה מקומית",
  "pages.forms_page.pages_forms_page_select_one_or_more_options": "בחר אפשרות אחת או יותר",
  "pages.forms_page.pages_forms_page_submit_form": "שלח טופס",
  "pages.forms_page.pages_forms_page_submitted": "נשלח",
  "pages.forms_page.pages_forms_page_visible_form": "טופס גלוי",
  "pages.forms_page.pages_forms_page_visible_forms": "טפסים גלויים",
  "pages.gallery_page.gallery_comments": "הערות גלריה",
  "pages.gallery_page.gallery_no_comments": "גלריה אין תגובות",
  "pages.gallery_page.pages_gallery_page_caption": "כיתוב",
  "pages.gallery_page.pages_gallery_page_occasion_wide": "ברמת האירוע",
  "pages.gallery_page.pages_gallery_page_uploading": "מעלה",
  "pages.integrations_page.pages_integrations_page_attempts": "ניסיונות",
  "pages.integrations_page.pages_integrations_page_auth": "אימות",
  "pages.integrations_page.pages_integrations_page_config_v": "תצורה גרסה",
  "pages.integrations_page.pages_integrations_page_connections": "חיבורים",
  "pages.integrations_page.pages_integrations_page_jobs": "משימות",
  "pages.integrations_page.pages_integrations_page_last_sync": "סנכרון אחרון",
  "pages.integrations_page.pages_integrations_page_mappings": "מיפויים",
  "pages.integrations_page.pages_integrations_page_never": "אף פעם",
  "pages.integrations_page.pages_integrations_page_recent_activity": "פעילות אחרונה",
  "pages.integrations_page.pages_integrations_page_to": "אל",
  "pages.placeholder_feature_page.pages_placeholder_feature_page_next_implementation_focus": "מוקד הפיתוח הבא",
  "pages.placeholder_feature_page.pages_placeholder_feature_page_review_occasions": "סקור אירועים",
  "pages.rsvp.rsvp_page.pages_rsvp_rsvp_page_share_a_note_or_any_special_requests": "שתפו הערה או בקשות מיוחדות...",
  "pages.schedule_page.pages_schedule_page_timeline_item": "פריט ציר זמן",
  "pages.seating.seating_areas_tab.pages_seating_seating_areas_tab_sort": "מיון",
  "publishing.settings.preset_label": "תבנית",
  "ui.opening_experience.classic_reveal_description": "חשיפה קלאסית",
  "ui.opening_experience.elegant_lift_description": "הרמה אלגנטית",
  "ui.opening_experience.envelope_description": "מעטפה",
  "ui.opening_experience.envelope_open_description": "פתיחת מעטפה",
  "ui.opening_experience.fade_description": "עמעום",
  "ui.opening_experience.folded_card_description": "כרטיס מקופל",
  "ui.opening_experience.interactive_envelope_description": "מעטפה אינטראקטיבית",
  "ui.opening_experience.none_description": "ללא",
  "ui.opening_experience.player_label": "חוויית פתיחת הזמנה",
  "ui.opening_experience.preview_label": "תצוגה מקדימה של פתיחת הזמנה",
  "ui.opening_experience.simple_fade_description": "עמעום פשוט",
  "ui.opening_experience.skip_animation": "דלג על אנימציה",
  "ui.opening_experience.soft_unfold_description": "פריסה עדינה"
}
